import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PersonalInformationContainer, Banner, Options, Option } from './myProfile.styles';
import GeneralInfo from './generalInfo/generalInfo';
import Address from './address/address';
import ContractsInfo from './contractsInfo/contractInfo';
import BankInfo from './bankInformation/bankInfo';
import {
  fetchAddressApplicantData,
  fetchBankApplicantData,
  fetchFilesInformation,
  fetchPersonalInformationApplicant
} from 'src/store/Profile/profile.slice';
import WithdrawCredit from './withdrawCredit/withdrawCredit';
import BusinessDocuments from './BusinessDocuments/BusinessDocuments';

export default function ApplicantProfile() {
  const [generalInfo, setGeneralInfo] = useState(true);
  const [address, setAddress] = useState(false);
  const [contractsInfo, setContractsInfo] = useState(false);
  const [bankInfo, setBankInfo] = useState(false);
  const [withdrawCredit, setWithdrawCredit] = useState(false);
  const [businessDocuments, setBusinessDocuments] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.currentUser);
  const personalInformation = useSelector((state) => state.profile.personalInformation);
  const bankInformation = useSelector((state) => state.profile.bankInformation);
  const addressInformation = useSelector((state) => state.profile.addressInformation);
  const filesInformation = useSelector((state) => state.profile.filesInformation);
  useEffect(() => {
    if (user.id) {
      dispatch(fetchPersonalInformationApplicant(user.id));
      dispatch(fetchBankApplicantData(user.id));
      dispatch(fetchAddressApplicantData(user.id));
      dispatch(fetchFilesInformation(user.id));
    }
  }, [user.id, dispatch]);

  const showGeneralInfo = () => {
    setGeneralInfo(true);
    setAddress(false);
    setContractsInfo(false);
    setBankInfo(false);
    setBusinessDocuments(false);
    setWithdrawCredit(false);
  };

  const showAddress = () => {
    setGeneralInfo(false);
    setAddress(true);
    setContractsInfo(false);
    setBankInfo(false);
    setBusinessDocuments(false);
    setWithdrawCredit(false);
  };

  const showContracts = () => {
    setGeneralInfo(false);
    setAddress(false);
    setContractsInfo(true);
    setBankInfo(false);
    setBusinessDocuments(false);
    setWithdrawCredit(false);
  };

  const showBankInfo = () => {
    setGeneralInfo(false);
    setAddress(false);
    setContractsInfo(false);
    setBankInfo(true);
    setBusinessDocuments(false);
    setWithdrawCredit(false);
  };

  const showWithdrawCredit = () => {
    setGeneralInfo(false);
    setAddress(false);
    setContractsInfo(false);
    setBankInfo(false);
    setBusinessDocuments(false);
    setWithdrawCredit(true);
  };

  const showBusinessDocuments = () => {
    setGeneralInfo(false);
    setAddress(false);
    setContractsInfo(false);
    setBankInfo(false);
    setBusinessDocuments(true);
    setWithdrawCredit(false);
  };
  return (
    <PersonalInformationContainer>
      <Banner>
        <figure>
          <img
            src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_inv_dash_my_profile_banner.png`}
            alt="Finsphera icono"
          />
        </figure>
        <h2>Mi perfil</h2>
        <p>
          En tu perfil podrás completar tus datos como solicitante en FinSphera y así realizar
          acciones en la plataforma.
        </p>
      </Banner>
      <Options>
        <Option isSelected={generalInfo} onClick={showGeneralInfo}>
          Datos de la PyME
        </Option>
        <Option isSelected={address} onClick={showAddress}>
          Dirección de la PyME
        </Option>
        <Option isSelected={contractsInfo} onClick={showContracts}>
          Contratos
        </Option>
        <Option isSelected={businessDocuments} onClick={showBusinessDocuments}>
          Mis documentos
        </Option>
        <Option isSelected={bankInfo} onClick={showBankInfo}>
          Datos bancarios
        </Option>
        <Option isSelected={withdrawCredit} onClick={showWithdrawCredit}>
          Campañas
        </Option>
      </Options>
      {generalInfo && <GeneralInfo personalInformation={personalInformation} />}
      {address && <Address addressInformation={addressInformation} />}
      {contractsInfo && <ContractsInfo />}
      {bankInfo && personalInformation && (
        <BankInfo bankInformation={bankInformation} personalInformation={personalInformation} />
      )}
      {businessDocuments && <BusinessDocuments filesInformation={filesInformation} />}
      {withdrawCredit && (
        <WithdrawCredit
          personalInformation={personalInformation}
          bankInformation={bankInformation}
        />
      )}
    </PersonalInformationContainer>
  );
}
